import api from '@/services/api'

const state = {
	codes: {
		ENER: 'Energia',
		CONS: 'Consumi',
		DISP: 'Dispacciamento',
		TRAR: 'Trasporto',
		IMPR: 'imposte',
	},
}

const getters = {}

const actions = {
	async list() {		
		const response = await api().get('/bill-audit')
		return response.data.data
	},
	async create({}, data) {
		const response = await api().put('/bill-audit/report', data)
		return response.data
	},
	async update({ }, data) {
		const response = await api().patch('/bill-audit/report', data)
		return response.data
	},
	async delete({ }, id) {
		await api().delete(`/bill-audit/report/${id}`)
	},
	async getInvoiceData({ }, id) {
		const response = await api().get(`/bill-audit/report/${id}/invoice`)
		return response.data
	},
	async upsertInvoiceData({ }, data) {
		const response = await api().post(`/bill-audit/report/invoice`, data)
		return response.data.data
	},
	async addInvoiceData({ }, data) {
		const response = await api().post(`/bill-audit/report/invoice/add`, data)
		return response.data.data
	},
	async deleteInvoiceData({ }, id) {
		const response = await api().delete(`/bill-audit/report/invoice/${id}`)
		return response.data
	},
	async getReport({ }, id) {
		const response = await api().get(`/bill-audit/report/${id}`)
		return response.data
	},
	async uploadPod({ }, data) {
		const params = new URLSearchParams()
		params.append('pod', data.pod)
		params.append('channelCode', data.channelCode)
		params.append('supplierName', data.supplier)
		params.append('from', data.from) 
		params.append('to', data.to)
		const response = await api().get(`/bill-audit/upload/consumption?${params}`)
		return response.data
	},
}

const mutations = {
	
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/billaudit.js